import React from "react";
import SalidaFields from "../../components/SalidaFields";

/**
 * Modal de confirmación de un movimiento de inventario (rediseño 2026-07).
 * Hereda el acento de la operación (--scan-accent) del contenedor del scanner,
 * así que se ve verde en entradas y rojo en salidas sin lógica extra.
 *
 * @param {Object} props
 * @param {boolean} props.isModalOpen
 * @param {Function} props.setIsModalOpen
 * @param {string} props.mode - 'add' | 'take'
 * @param {Array} props.processedItems
 * @param {Function} props.confirmInventoryOperation
 * @param {boolean} props.isConfirming
 * @param {string} props.motivo
 * @param {Function} props.setMotivo
 * @param {Array} props.plantas
 */
const ConfirmationModal = React.memo(
  ({
    isModalOpen,
    setIsModalOpen,
    mode,
    processedItems,
    confirmInventoryOperation,
    isConfirming,
    motivo = "",
    setMotivo = () => {},
    plantas = [],
    salida, setSalida, salidaErrors, plantasError,
  }) => {
    if (!isModalOpen) return null;

    const isSalida = mode !== "add";
    const operationType = mode === "add" ? "Entrada" : "Salida";
    const totalUnidades = processedItems.reduce(
      (sum, item) => sum + (Number(item.cantidad) || 0),
      0,
    );

    const close = () => { if (!isConfirming) setIsModalOpen(false); };

    return (
      <div
        className={`scan-modal-overlay ${mode === "add" ? "mode-add" : "mode-take"}`}
        onClick={close}
      >
        <div
          className="scan-modal"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="scan-modal-head">
            <span className="scan-modal-icon" aria-hidden="true">
              <i className={`fa-solid ${mode === "add" ? "fa-plus" : "fa-minus"}`}></i>
            </span>
            <div className="scan-modal-head-text">
              <h2 className="scan-modal-title">Confirmar {operationType.toLowerCase()}</h2>
              <p className="scan-modal-sub">
                Revisa los datos antes de registrar el movimiento.
              </p>
            </div>
            <button
              type="button"
              className="scan-modal-close"
              onClick={close}
              aria-label="Cerrar"
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div className="scan-modal-body">
            <div className="scan-modal-summary">
              <div className="scan-modal-stat">
                <span>Tipo</span>
                <strong className="scan-modal-type">{operationType}</strong>
              </div>
              <div className="scan-modal-stat">
                <span>Productos</span>
                <strong>{processedItems.length}</strong>
              </div>
              <div className="scan-modal-stat">
                <span>Unidades</span>
                <strong>{totalUnidades}</strong>
              </div>
            </div>

            <div className="scan-modal-items">
              <span className="scan-modal-items-title">Detalle</span>
              <ul className="scan-modal-items-list">
                {processedItems.map((item, index) => (
                  <li className="scan-modal-item" key={item.codigo || index}>
                    <div className="scan-modal-item-info">
                      <span className="scan-modal-item-name">
                        {item.descripcion || "Producto sin nombre"}
                      </span>
                      <span className="scan-modal-item-meta">
                        {item.medida && item.medida !== "-" ? item.medida : "N/A"}
                        {item.tipo && item.tipo !== "-" ? ` · ${item.tipo}` : ""}
                      </span>
                    </div>
                    <span className="scan-modal-item-qty">×{item.cantidad}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="scan-modal-fields">
              {isSalida ? <SalidaFields prefix="scan-salida" value={salida} onChange={setSalida} plantas={plantas} plantasError={plantasError} errors={salidaErrors} disabled={isConfirming} /> :
                <label className="scan-modal-field"><span className="scan-modal-label">Motivo (opcional)</span><input type="text" value={motivo} onChange={e => setMotivo(e.target.value)} disabled={isConfirming} maxLength={255} /></label>}

            </div>
          </div>

          <div className="scan-modal-foot">
            <button
              type="button"
              className="scan-modal-btn ghost"
              onClick={close}
              disabled={isConfirming}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="scan-modal-btn primary"
              onClick={confirmInventoryOperation}
              disabled={isConfirming}
            >
              {isConfirming ? (
                <>
                  <span className="scan-modal-spinner"></span> Procesando…
                </>
              ) : (
                <>
                  <i className={`fa-solid ${mode === "add" ? "fa-plus" : "fa-minus"}`}></i>{" "}
                  Confirmar {operationType.toLowerCase()}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  },
);

export default ConfirmationModal;
